import { toast } from 'react-toastify';
import { authAxiosInstance } from '../../utils/axiosConfig';

export const createJobWork = async (data) => {
    try {
        const createResp = await authAxiosInstance.post('/jobWork', data);
        return createResp;
    } catch (error) {
        console.log(error);
        toast.error('failed to create job work');
    }
};

export const updateJobWork = async (data) => {
    try {
        const createResp = await authAxiosInstance.patch('/jobWork', data);
        return createResp;
    } catch (error) {
        console.log(error);
        toast.error('failed to create job work');
    }
};

export const deleteJobWork = async (id) => {
    try {
        const deleteResp = await authAxiosInstance.delete(`/jobWork/${id}`);
        return deleteResp.data;
    } catch (error) {
        console.log(error);
        showError(error);
    }
};
